import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Input } from '../components';
import { themeVars } from '../config/theme';
import { authService } from '../services';
import '../styles/Login.scss';

const Login = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    username: '',
    password: '',
  });
  const [errors, setErrors] = useState({
    username: '',
    password: '',
    general: '',
  });
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    // Clear error when user starts typing
    setErrors((prev) => ({
      ...prev,
      [name]: '',
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors({ username: '', password: '', general: '' });
    setIsLoading(true);

    try {
      const response = await authService.login(formData.username, formData.password);
      localStorage.setItem('access_token', response.access);
      localStorage.setItem('refresh_token', response.refresh);
      window.location.href = '/select-context';
    } catch (error) {
      setErrors((prev) => ({
        ...prev,
        general: error.response?.data?.detail || 'Login failed. Please try again.',
      }));
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-folder themed" style={themeVars('finance')}>
        <div className="login-tab">NPI Governance</div>
        <div className="login-body">
        <form className="login-sheet" onSubmit={handleSubmit}>
          <h1>Sign in</h1>
          <p className="login-sub">Open your company's B-BBEE file.</p>
          {errors.general && <div className="banner banner-error">{errors.general}</div>}
          <Input
            label="Username"
            type="text"
            name="username"
            placeholder="Enter your username"
            value={formData.username}
            onChange={handleChange}
            error={errors.username}
            required
          />
          <Input
            label="Password"
            type="password"
            name="password"
            placeholder="Enter your password"
            value={formData.password}
            onChange={handleChange}
            error={errors.password}
            required
          />
          <Button type="submit" fullWidth disabled={isLoading}>
            {isLoading ? 'Signing in...' : 'Sign in'}
          </Button>
          <div className="login-footer">
            <p>
              Don't have an account?{' '}
              <button type="button" className="link-button" onClick={() => navigate('/register')}>
                Register here
              </button>
            </p>
          </div>
        </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
